import { useState } from "react";

type Props = {
  onConfirm: (reason: string) => void;
  onCancel: () => void;
};

export function RejectDialog({ onConfirm, onCancel }: Props) {
  const [reason, setReason] = useState("");
  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-surface rounded-lg shadow-xl w-[420px] p-5">
        <h2 className="text-lg font-semibold mb-1">Reject this Rx</h2>
        <p className="text-ink-soft text-sm mb-4">
          Rejecting is terminal — the Rx will not be imported to PK. Use Hold if you're just waiting for info.
        </p>
        <label className="block text-xs text-ink-soft mb-1">Reason</label>
        <textarea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Why is this being rejected?"
          className="w-full px-2.5 py-1.5 border border-border rounded text-sm min-h-[64px] resize-y mb-4"
        />
        <div className="flex justify-end gap-2">
          <button type="button" onClick={onCancel} className="px-3 py-1.5 border border-border rounded text-sm">
            Cancel
          </button>
          <button
            type="button"
            disabled={!reason.trim()}
            onClick={() => onConfirm(reason.trim())}
            className="px-3 py-1.5 bg-bad text-white rounded text-sm font-medium disabled:opacity-40 disabled:cursor-not-allowed"
          >
            Reject Rx
          </button>
        </div>
      </div>
    </div>
  );
}
